'use strict';

export default function($stateProvider) {
  'ngInject';

  /*
  $stateProvider
    .state('calendar-community-list', {
      url: '/calendar/community/list',
      template: '<calendar-list type="community"></calendar-list>',
        authenticate: true
    })
    .state('calendar-reservation-list', {
      url: '/calendar/reservation/list',
      template: '<calendar-list type="reservation"></calendar-list>',
        authenticate: true
    })
    .state('calendar-member-list', {
      url: '/calendar/member/list',
      template: '<calendar-list type="member"></calendar-list>',
        authenticate: true
    });
    */
}



// WEBPACK FOOTER //
// ./client/app/calendar/list/calendar-list.routes.js